/**
 * @generated SignedSource<<6c63b1e49008a473777214c8c04af293>>
 * @relayHash bf433dd55cb5e7779366a5c70983e76d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 473f165d297ccb666ad3688bbe9525b403ec8a6c2ac02fd1d712c6f5874a6aae

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceAnalyticsAccountType = "AGENT" | "USER" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type usePageViewsAnalyticsViewersWithoutLimitQuery$variables = {
  contentId: string;
  engageTimeThreshold?: number | null;
  isPrivacyModeEnabled?: boolean | null;
};
export type usePageViewsAnalyticsViewersWithoutLimitQuery$data = {
  readonly singleContent: {
    readonly contentAnalyticsViewsByUser: {
      readonly pageViews: ReadonlyArray<{
        readonly accountType: ConfluenceAnalyticsAccountType | null;
        readonly agentType: string | null;
        readonly confluenceUser: {
          readonly permissionType: SitePermissionType | null;
        } | null;
        readonly isEngaged: boolean | null;
        readonly lastVersionViewedNumber: number | null;
        readonly lastVersionViewedUrl: string | null;
        readonly lastViewedAt: string;
        readonly relatedUser: {
          readonly displayName: string | null;
          readonly id: string | null;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly relatedUserAccountId: string | null;
        readonly userProfile: {
          readonly displayName: string | null;
          readonly id: string | null;
          readonly isActive: boolean | null;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly views: number;
      }>;
    } | null;
    readonly id: string | null;
    readonly subType: string | null;
    readonly version: {
      readonly number: number | null;
    } | null;
  } | null;
};
export type usePageViewsAnalyticsViewersWithoutLimitQuery = {
  response: usePageViewsAnalyticsViewersWithoutLimitQuery$data;
  variables: usePageViewsAnalyticsViewersWithoutLimitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "engageTimeThreshold"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isPrivacyModeEnabled"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "subType"
},
v4 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ]
},
v5 = [
  {
    "kind": "Variable",
    "name": "engageTimeThreshold",
    "variableName": "engageTimeThreshold"
  },
  {
    "kind": "Variable",
    "name": "isPrivacyModeEnabled",
    "variableName": "isPrivacyModeEnabled"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "concreteType": "AtlassianUserPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "value"
    },
    {
      "kind": "ScalarField",
      "name": "isPrimary"
    }
  ]
},
v8 = {
  "concreteType": "ContentAnalyticsPageViewInfo",
  "kind": "LinkedField",
  "name": "pageViews",
  "plural": true,
  "selections": [
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isActive"
        }
      ]
    },
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluenceUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "permissionType"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "accountType"
    },
    {
      "kind": "ScalarField",
      "name": "agentType"
    },
    {
      "kind": "ScalarField",
      "name": "relatedUserAccountId"
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "relatedUser",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/)
      ]
    },
    {
      "kind": "ScalarField",
      "name": "views"
    },
    {
      "kind": "ScalarField",
      "name": "lastViewedAt"
    },
    {
      "kind": "ScalarField",
      "name": "lastVersionViewedNumber"
    },
    {
      "kind": "ScalarField",
      "name": "lastVersionViewedUrl"
    },
    {
      "kind": "ScalarField",
      "name": "isEngaged"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "usePageViewsAnalyticsViewersWithoutLimitQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": (v5/*: any*/),
            "concreteType": "ContentAnalyticsViewsByUser",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewsByUser",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePageViewsAnalyticsViewersWithoutLimitQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "args": (v5/*: any*/),
            "concreteType": "ContentAnalyticsViewsByUser",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewsByUser",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "bf433dd55cb5e7779366a5c70983e76d",
    "id": "473f165d297ccb666ad3688bbe9525b403ec8a6c2ac02fd1d712c6f5874a6aae",
    "metadata": {},
    "name": "usePageViewsAnalyticsViewersWithoutLimitQuery",
    "operationKind": "query",
    "text": "query usePageViewsAnalyticsViewersWithoutLimitQuery($contentId:ID!,$engageTimeThreshold:Int,$isPrivacyModeEnabled:Boolean){singleContent(id:$contentId){id,subType,version{number},contentAnalyticsViewsByUser(engageTimeThreshold:$engageTimeThreshold,isPrivacyModeEnabled:$isPrivacyModeEnabled){pageViews{userProfile{id,displayName,photos{value,isPrimary},isActive},confluenceUser{permissionType},accountType,agentType,relatedUserAccountId,relatedUser{id,displayName,photos{value,isPrimary}},views,lastViewedAt,lastVersionViewedNumber,lastVersionViewedUrl,isEngaged},id}}}"
  }
};
})();

(node as any).hash = "d68405636bde80879b4472474acc7681";

export default node;
